<template>
    <Modal
            v-model="_value"
            width="400"
            title="修改设备维修记录"
            @on-visible-change="visibleChange"
            ok-text="确认"
            @on-ok="onOk"
            @on-cancel="onCancel">
        <div style="position:relative;">
            <Form ref="maintainDeviceRecordRef" :model="maintainDeviceRecord" :label-width="80">
<!--                <FormItem prop="content" label="主机号">-->
<!--                    <Select v-model="maintainDeviceRecord">-->
<!--                        <Option v-for="item in devices" :value="item" :key="item.id">{{item.terminalNum+'('+ (item.positioningDeviceInfo.positioningDeviceModel == null ? '无' : item.positioningDeviceInfo.positioningDeviceModel.name) +')'}}</Option>-->
<!--                    </Select>-->
<!--                </FormItem>-->

                <FormItem label="主机号">
                    <Input readonly v-model="maintainDeviceRecord.terminalNum"></Input>
                </FormItem>

                <FormItem label="是否换机">
                    <Checkbox v-model="maintainDeviceRecord.changeDevice"></Checkbox>
<!--                        <Input v-if="maintainDeviceRecord.changeDevice" v-model="maintainDeviceRecord.newFactoryTerminalNum"></Input>-->
<!--                        <Select v-if="maintainDeviceRecord.changeDevice" v-model="maintainDeviceRecord.newPositioningDeviceModelId">-->
<!--                            <Option v-for="(option, index) in positioningDeviceModelOptions" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>-->
<!--                        </Select>-->
                </FormItem>
                <FormItem v-if="maintainDeviceRecord.changeDevice" prop="newFactoryTerminalNum" label="新设备出厂主机号">
                    <Input v-model="maintainDeviceRecord.newFactoryTerminalNum"></Input>
                </FormItem>
                <FormItem v-if="maintainDeviceRecord.changeDevice" prop="newEncryptionchipnumber" label="设备芯片码">
                    <Input v-model="maintainDeviceRecord.newEncryptionchipnumber"></Input>
                </FormItem>
                <FormItem v-if="maintainDeviceRecord.changeDevice" prop="newPositioningDeviceModelId" label="新设备型号">
                    <!--                    <Input v-model="maintainDeviceRecord.newPositioningDeviceModel"></Input>-->
                    <Select v-model="maintainDeviceRecord.newPositioningDeviceModelId">
                        <Option v-for="item in PositioningDeviceModellist" :value="item.val" :key="item.val">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <FormItem label="是否换卡">
                    <Checkbox v-model="maintainDeviceRecord.changeSim"></Checkbox>
<!--                        <Input v-if="maintainDeviceRecord.changeSim" v-model="maintainDeviceRecord.newTerminalNum"></Input>-->
                </FormItem>
                <FormItem v-if="maintainDeviceRecord.changeSim" prop="newTerminalNum" label="新设备主机号">
                    <Input v-model="maintainDeviceRecord.newTerminalNum"></Input>
                </FormItem>
                <FormItem v-if="maintainDeviceRecord.changeSim" prop="newTerminalNum" label="修改主机号">
                    <Checkbox v-model="maintainDeviceRecord.changeTerminalNum"><span>设备是否使用新主机号</span></Checkbox><br>
                    <span style="color: red">视频机默认不修改，部标机根据情况自行勾选（默认需要修改）</span>
                </FormItem>


                <FormItem label="是否拆机">
                    <Checkbox :disabled="maintainDeviceRecord.changeDevice || maintainDeviceRecord.changeSim" v-model="maintainDeviceRecord.removeDevice" @on-change="getRemoveDevice"></Checkbox>
                    <Checkbox v-if="maintainDeviceRecord.removeDevice" :disabled="maintainDeviceRecord.changeDevice || maintainDeviceRecord.changeSim" v-model="maintainDeviceRecord.deviceRecycle"><span>拆除设备是否可使用</span></Checkbox>
                </FormItem>

            </Form>
            <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="dataLoading">
                <Spin size="large"></Spin>
                <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
            </div>
        </div>
    </Modal>
</template>

<script>
    import Vue from 'vue';
    import {mapActions} from 'vuex'
    import store from '@/store'
    import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

    export default {
        name: "maintain-order-modify-maintain-device-record-modal",
        props: {
            value: {
                type: Boolean,
                default: false
            },
            initValue: null
        },
        data(){
            return{
                PositioningDeviceModellist:[
                    // {name: 'BSJ-A6-BD', val: 1},
                    // {name: 'BSJ-GF03', val: 2},
                    // {name: 'BSJ-M11', val: 3},
                    // {name: 'K5', val: 4},
                    // {name: 'D5X', val: 5},
                    // {name: 'G-3G', val: 6},
                    // {name: 'D5X-HDD', val: 7},
                    // {name: 'D5X-XR', val: 8},
                    // {name: 'BSJ-GF06', val: 9},
                    // {name: 'BSJ-RM01', val: 10},
                    // {name: 'HIK-A3', val: 11},
                    // {name: 'HIK-A3L', val: 12},
                    // {name: 'BSJ-A6L', val: 13},
                    // {name: 'BSJ-A7', val: 14},
                ],

                devices: [],
                selectDevice: null,
                dataLoading: false,

                positioningDeviceModelOptions: [],

                maintainDeviceRecord: {
                    terminalNum: null,
                    newTerminalNum: null,
                    newFactoryTerminalNum: null,
                    newEncryptionchipnumber: null,
                    newPositioningDeviceModelId: null,
                    changeDevice: false,
                    changeSim: false,
                    changeTerminalNum: false,
                    removeDevice: false,
                    deviceRecycle: false,
                    positioningDeviceInfoId: null,
                    positioningDeviceInfo: null,
                    result: null,
                    maintainOrderId: null,
                }
            }
        },
        methods: {
            ...mapActions([
                'MaintainOrderServ_AddMaintainDeviceRecord'
            ]),
            onOk() {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>确认修改</p>',
                    onOk: () => {
                        // this.maintainDeviceRecord = this.selectDevice
                        // console.log(this.selectDevice)
                        console.log(this.maintainDeviceRecord)
                        if (this.maintainDeviceRecord.changeDevice || this.maintainDeviceRecord.changeSim) {
                            this.maintainDeviceRecord.removeDevice = false
                            this.maintainDeviceRecord.deviceRecycle = false
                        }
                        store.dispatch('MaintainOrderServ_ModifyMaintainDeviceRecord', {
                            params: this.maintainDeviceRecord
                        }).then(() => {
                            this.$Message.success('修改成功')
                            this.$emit('on-success')

                            // //确认订单
                            // store.dispatch('MaintainOrderServ_ConfirmMaintained', {
                            //     params: {id: this.maintainDeviceRecord.maintainOrderId}
                            // }).then(() => {
                            //     this.$Message.success('后台确认维修完成')
                            //     this.onLoad()
                            // }).catch(err => {
                            //     this.$Message.error(err)
                            // })

                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                        })
                    },
                    onCancel: () => {

                    }
                })
            },
            onCancel(){
                this.$emit('on-success')
            },
            getPositioningDeviceType(){
                store.dispatch('PositioningDeviceTypeServ_GetAll', {
                    params: {},
                    urlparams: null
                }).then(() => {
                    this.positioningDeviceModelOptions = store.getters.get_PositioningDeviceType_GetAllResult
                }).catch(err => {
                    console.log(err)
                })
            },
            getRemoveDevice(){
                if (this.maintainDeviceRecord.removeDevice) {
                    this.maintainDeviceRecord.changeDevice =false
                    this.maintainDeviceRecord.newFactoryTerminalNum =null
                    this.maintainDeviceRecord.newPositioningDeviceModel =null
                    this.maintainDeviceRecord.newPositioningDeviceModelId =null
                    this.maintainDeviceRecord.changeSim =false
                    this.maintainDeviceRecord.newTerminalNum =null
                }
            },
            visibleChange(val) {
                console.log(val)
                if (val) {
                    this.selectDevice = null
                    this.maintainDeviceRecord = this._initValue
                    console.log(this.maintainDeviceRecord)
                    // store.dispatch('MaintainOrderServ_GetDetail', {
                    //     params: {id: this._initValue},
                    //     urlparams: null
                    // }).then(() => {
                    //     if (store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords) {
                    //         this.devices = store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords
                    //     }
                    // }).catch(err => {
                    //     this.$Message.error(err)
                    // })

                    this.getPositioningDeviceType()
                }
            }
        },
        computed: {
            _value: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val)
                    this.$emit('change', val)
                }
            },
            _initValue: {
                get() {
                    return this.initValue
                },
                set(val) {
                    // this.$emit('input', val);
                    // this.$emit('change', val);
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                store.dispatch('PositioningDeviceTypeServ_GetAll',{
                    params:null,
                    urlparams:null
                }).then(()=>{

                    if (store.getters.get_PositioningDeviceType_GetAllResult) {
                        store.getters.get_PositioningDeviceType_GetAllResult.forEach(item=>{
                            this.PositioningDeviceModellist.push({name: item.name, val: item.id},)
                        })
                    }
                }).catch(err=>{
                    console.log(err)
                })
            })
        }
    }
</script>

<style scoped>

</style>
